<template>
  <div class="common-page contour">
    <slot name="img-icon"></slot>
    <div class="common-box">
<!--      <div class="common-logo contour">-->
<!--        <slot name="logo"></slot>-->
<!--      </div>-->
      <slot></slot>
    </div>
    <div class="common-footer">
      <p>
        <span style="margin-right: 15px">茂名家安信信息技术有限公司</span>
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021118223号-3</a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CommonPage",
  }
</script>

<style scoped lang="scss">
  .common-page {
    width: 100%;
    height: 100%;
    background: linear-gradient(-90deg, #0a48d1 0%, #1183fb 100%);
    position: relative;
    text-align: center;
    overflow-y: auto;
    overflow-x: hidden;
    .common-img {
      display: inline-block;
      width: 500px;
      height: 440px;
      vertical-align: middle;
      margin-right: 10%;
      background-image: url("~@assets/img/common-img.png");
      background-size: 100%;
    }
    .common-box {
      display: inline-block;
      vertical-align: middle;
      max-width: 400px;
      width: 90%;
      position: relative;
      z-index: 99;
      box-sizing: border-box;
      padding: 30px 60px;
      border-radius: 5px;
      border: 1px solid #ddd;
      background-color: #fff;
      .common-logo {
        width: 100px;
        height: 100px;
        border: 5px solid $home-color;
        border-radius: 100px;
        background: #fff;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: $home-color;
        i {
          vertical-align: middle;
          font-size: 50px;
        }
      }
    }
    @media screen and (max-width:1050px){
      .common-img{
        display: none;
      }
    }
    @media screen and (max-width:450px){
      .common-box{
        padding: 60px 30px 30px;
      }
    }
    @media screen and (max-width:400px){
      .common-box{
        padding: 60px 15px 30px;
      }
    }
    .common-footer {
      text-align: center;
      position: absolute;
      color: #fff;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 14px;
      line-height: 1.8;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
  }
</style>
